import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
//api
import { getProducts } from 'api/products';
//components
import AutoCompleteInput from './autoCompleteInput';

const SearchProduct = ({
  filterBy,
  onSelected,
  placeholder,
  defaultArticle = null,
  showLabel = '',
  fields = 'id,title,image,ean',
}) => {
  const [articleSelected, setArticleSelected] = useState(null);

  useEffect(() => {
    if (defaultArticle) {
      setArticleSelected({
        label: filterBy === 'ean' ? defaultArticle.ean : defaultArticle.title,
        value: defaultArticle.id,
      });
    } else setArticleSelected(null);
  }, [defaultArticle]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      const { status, data } = await getProducts({
        [filterBy]: value,
        page: 1,
        page_size: 10,
        fields: fields,
      });
      if (status === 200) {
        return data?.results?.map((item) => {
          return {
            ...item,
            label: `${item.title} (${item.ean})`,
            value: item.id,
          };
        });
      }
    }
    return [];
  };

  return (
    <AutoCompleteInput
      label={showLabel}
      defaultOptions={articleSelected ? [articleSelected] : []}
      defaultValue={articleSelected}
      onSelect={onSelected}
      onSearch={onSearch}
      placeholder={placeholder}
    />
  );
};

SearchProduct.propTypes = {
  filterBy: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onSelected: PropTypes.func.isRequired,
  defaultArticle: PropTypes.object,
  showLabel: PropTypes.string,
  fields: PropTypes.string,
};

export default SearchProduct;
